import React from 'react'
import { ScaleLinear } from 'd3-scale'
import { nF } from '../'
import './styles.scss'
export const Value = ({
  value,
  x,
  y,
  circle = false,
  offset = 0,
  textAnchor = 'middle',
  line = false,
  unit
}: {
  value: number
  x: number
  y: ScaleLinear<number, number>
  circle?: boolean
  offset?: number
  textAnchor?: 'middle' | 'start' | 'end'
  line: boolean
  unit?: string
}) => {
  let lastVal = {
    x: x + 5,
    y: y.range()[0] - y(value) - offset,
    text: value
  }
  return (
    <g className='Value'>
      <text x={lastVal.x} y={lastVal.y} textAnchor={textAnchor}>
        {+lastVal.text > 9999
          ? nF(+lastVal.text.toFixed(0)) + (unit ? unit : '')
          : +lastVal.text.toFixed(0) + (unit ? unit : '')}
      </text>
      {line && (
        <line
          x1={lastVal.x}
          x2={lastVal.x}
          y1={lastVal.y + 4}
          y2={lastVal.y + offset}
        />
      )}
      {circle && <circle cx={lastVal.x} cy={lastVal.y + offset} r={3} />}
    </g>
  )
}
